import { TooltipWrapper } from "../Tooltip";
import { Typo } from "../Typo";

export const BannerHeaderCell = ({ text }: { text: string }) => (
  <Typo type="bodyXS" textColor="text-text-secondary">
    {text}
  </Typo>
);

export const BannerDataCell = ({
  text,
  textColor,
  className = "truncate",
}: {
  text?: string;
  textColor?: string;
  className?: string;
}) => (
  <Typo type="bodyMD" textColor={textColor} className={className}>
    {text ?? ""}
  </Typo>
);

export const BannerTooltipText = ({
  text,
  tooltipText,
}: {
  text?: string;
  tooltipText?: string;
}) => (
  <TooltipWrapper text={tooltipText ?? ""} color="blue" tooltipPlacement="top">
    <Typo type="bodyMD" className="truncate">
      {text ?? ""}
    </Typo>
  </TooltipWrapper>
);
